export const translations = {
  en: {
    nav: { shop: "Shop", story: "Our Story", howto: "How to Order", cart: "Cart", menu: "Menu", close: "Close" },
    hero: {
      overline: "Saudi Specialty Coffee — Now in Egypt",
      line1: "MAGIC IN",
      line2: "EVERY CUP",
      sub: "Premium 250g coffee bags crafted for daily rituals, delivered to your door with Cash on Delivery.",
      cta: "Shop Coffee",
      scroll: "Scroll to enter",
    },
    film: {
      overline: "From the farm to your cup",
      cta: "Shop Coffee",
      chapters: {
        farm: "The Farm",
        cherry: "The Cherry",
        harvest: "The Harvest",
        process: "The Process",
        roast: "The Roast",
        brew: "The Brew",
      },
    },
    marquee: ["MAGIC IN EVERY CUP", "CAFÉXIR", "السحر في كل كوب", "COFFEE AS ELIXIR"],
    journey: {
      overline: "The Journey",
      title: "From Farm to Magic",
      listen: "Listen to the Guji highlands",
      mute: "Mute the highlands",
      swipeHint: "Swipe right or left to explore the journey",
      prev: "Previous",
      next: "Next",
      steps: {
        farm: { title: "The Farm", text: "Highland farms at first light — where every cup begins." },
        cherry: { title: "The Cherry", text: "Ripe fruit, picked only at its deepest red." },
        harvest: { title: "The Harvest", text: "Hand-selected, one cherry at a time." },
        process: { title: "The Process", text: "Washed or natural — time and sun shape the bean." },
        roast: { title: "The Roast", text: "Fire, air and instinct unlock the elixir." },
        brew: { title: "The Brew", text: "Water meets ground. The ritual completes." },
        cup: { title: "The Cup", text: "The journey ends where the magic begins — in your hands." },
      },
    },
    manifesto: {
      overline: "The Manifesto",
      chapters: [
        {
          number: "01",
          title: "The Ritual",
          content:
            "Coffee is not mere sustenance. It is an awakening — a sacred pause where time slows and clarity rises from dark waters.",
        },
        {
          number: "02",
          title: "The Source",
          content:
            "From the high forests of Guji to the ancient lands of Kaffa, we select only beans that carry a distinct soul and story.",
        },
        {
          number: "03",
          title: "The Bridge",
          content:
            "Uniting Saudi coffee heritage with Egypt's vibrant culture. CAFÉXIR brings a new standard of specialty coffee to Cairo.",
        },
      ],
    },
    collection: {
      overline: "Discover the Coffee",
      title: "Four Worlds, One Ritual",
      sub: "Each coffee is a small universe of its own. Step inside.",
      viewAll: "Explore the collection",
      discover: "Enter",
    },
    editorial: {
      overline: "Our Story",
      title: "From Riyadh to Cairo",
      body: "CAFÉXIR was born from a simple conviction — that a cup of coffee can be a small daily ceremony. Saudi in origin, now arriving in Egypt.",
      cta: "Read our story",
    },
    product: {
      back: "Back to collection",
      weight: "250g",
      notes: "Tasting Notes",
      specs: "Specifications",
      sensory: "Sensory Profile",
      type: "Type",
      origin: "Origin",
      brew: "Brew",
      altitude: "Altitude",
      process: "Process",
      roast: "Roast",
      form: "Form",
      flavor: "Flavor",
      composition: "Composition",
      variety: "Variety",
      addToCart: "Add to Cart",
      added: "Added to your cart",
      grindLabel: "Grind",
      grind: { whole: "Whole Beans", ground: "Ground" },
      available: "Available",
      unavailable: "Currently unavailable",
      share: "Share",
      linkCopied: "Link copied",
      codNote: "Cash on Delivery",
      freeShipHint: "Free delivery on orders over EGP 2,500",
      value: {
        caramel: "Caramel-flavoured filter coffee. Medium-dark roast, whole beans — 80% Arabica, 20% Robusta.",
        "ethiopia-guji": "Strawberry, lime and caramel — a washed Heirloom from the Guji highlands, grown at 1900–2300m.",
        "ethiopia-dijammah": "Chocolate, lemon citrus and berry — naturally processed in Kaffa, the ancient home of coffee.",
        vanilla: "Vanilla-flavoured filter coffee. Medium-dark roast, whole beans — 80% Arabica, 20% Robusta.",
      },
      recipes: {
        title: "The Official Rituals",
        sub: "Precise ratios, exactly as our roastery intends.",
        suggested: "Suggested brew method",
        hot: "HOT V60",
        iced: "ICED V60",
        dose: "Coffee",
        water: "Water",
        hotWater: "Hot water",
        temp: "Temperature",
        ice: "Ice",
        total: "Total (water + ice)",
        pours: "Pours",
        pour: "Pour",
        share: "Share the ritual",
        shared: "Card saved — ready to post",
        iceSteps: [
          "Place the ice in the server before brewing.",
          "Brew directly over the ice, letting the hot coffee drip onto it.",
          "After brewing, gently swirl the server to chill and combine.",
        ],
      },
      detailsPending: "Further details will be published with the official launch.",
      placeholder: "—",
      quantity: "Quantity",
      body: "Body",
      acidity: "Acidity",
      aftertaste: "Aftertaste",
      sweetness: "Sweetness",
      packPlaceholder: "Official pack photography — placeholder",
    },
    cart: {
      title: "Your Cart",
      empty: "Your cart is empty.",
      emptyCta: "Discover the collection",
      subtotal: "Subtotal",
      shipping: "Delivery",
      free: "Free",
      shippingPending: "Confirmed at contact",
      freeProgress: "Add {amount} more for free delivery",
      freeUnlocked: "Your order qualifies for free delivery",
      checkout: "Checkout — Cash on Delivery",
      remove: "Remove",
    },
    footer: {
      tagline: "Magic in every cup",
      line: "Saudi specialty coffee — Riyadh to Cairo.",
      contact: "Contact",
      howto: "How to Order",
      faq: "FAQ",
      policies: "Policies",
      codLine: "Cash on Delivery · Free Delivery over EGP 2,500",
      rights: "© 2026 CAFÉXIR. All rights reserved.",
    },
    story: {
      overline: "Our Story",
      title: "Coffee as Elixir",
      cta: "Explore the collection",
    },
    concierge: {
      title: "The Elixir Guide",
      open: "Ask the Elixir Guide",
      greeting: "Welcome to CAFÉXIR. Tell me your taste — bright, deep, or sweet — and I will find your elixir.",
      placeholder: "Ask about our coffees…",
      send: "Send",
      unavailable: "The guide is resting for a moment — please try again shortly.",
      listen: "Listen to the answer",
      suggestions: ["Which coffee suits me?", "How do I brew Ethiopia Guji?", "What makes CAFÉXIR different?"],
    },
    auth: {
      signIn: "Sign in",
      signOut: "Sign out",
      title: "Your CAFÉXIR account",
      subtitle: "MEMBERS OF THE RITUAL",
      signin: "Sign In",
      signup: "Create Account",
      name: "Name",
      email: "Email",
      password: "Password (8+ characters)",
      forgot: "Forgot password?",
      resetSent: "If this email exists, a reset link has been prepared.",
      emailRequired: "Enter your email first.",
      or: "or",
      google: "Continue with Google",
      error: "Something went wrong. Please try again.",
    },
    checkout: {
      title: "Checkout",
      subtitle: "CASH ON DELIVERY",
      name: "Full name",
      phone: "Phone number",
      email: "Email (optional — for order updates)",
      governorate: "Governorate",
      city: "City / area (optional)",
      address: "Detailed address",
      landmark: "Landmark (optional)",
      notes: "Delivery notes (optional)",
      summary: "Order summary",
      codNote: "Payment method: Cash on Delivery",
      confirm: "Confirm order — pay on delivery",
      placing: "Placing your order…",
      successTitle: "Your order is in",
      successBody: "We will contact you to confirm your order. Keep your order number:",
      continueShopping: "Continue exploring",
      required: "This field is required",
      phoneInvalid: "Enter a valid phone number",
      emailInvalid: "Enter a valid email address",
      error: "Something went wrong. Please try again.",
      empty: "Your cart is empty.",
      total: "Total due on delivery",
    },
    cupprint: {
      overline: "CAFÉXIR CUPPRINT",
      title: "Your taste. Your coffee. Your signature.",
      sub: "Four quick questions — and your elixir reveals itself.",
      qTaste: "What do you lean toward?",
      sweet: "Sweet & warm",
      balanced: "Balanced",
      bright: "Bright & lively",
      qBody: "Body?",
      light: "Light",
      full: "Full",
      qNotes: "Notes you love",
      nChocolate: "Chocolate",
      nFruity: "Fruity",
      nCitrus: "Citrus",
      nCaramel: "Caramel",
      nVanilla: "Vanilla",
      nBerry: "Berry",
      qBrew: "How do you brew?",
      espresso: "Espresso",
      filter: "Filter",
      both: "Both",
      resultTitle: "Your Cupprint",
      match: "match",
      because: "Why it fits you",
      recipe: "Your brew ritual",
      feedback: "Tried it? Tell the guide",
      liked: "Loved it",
      notLiked: "Not for me",
      restart: "Retake",
      next: "Continue",
      start: "Begin",
      viewProduct: "View your coffee",
      step: "of",
      reasons: {
        sweet: "you lean sweet and warm",
        bright: "you lean bright and lively",
        balanced: "you love balance",
        espresso: "you brew espresso",
        filter: "you brew filter",
        note_caramel: "you love caramel",
        note_vanilla: "you love vanilla",
        note_fruity: "you love fruity notes",
        note_citrus: "you love citrus",
        note_chocolate: "you love chocolate",
        note_berry: "you love berry",
      },
    },
    account: {
      title: "My Account",
      orders: "My Orders",
      cupprint: "My Cupprint",
      none: "Nothing here yet.",
      signinNeeded: "Sign in to view your account.",
      reorder: "Reorder",
      reordered: "Added to your cart",
      total: "Total",
      placedOn: "Placed",
      adminLink: "Admin panel",
      noCupprint: "Discover your Cupprint — four questions, one elixir.",
      match: "match",
    },
    admin: {
      title: "CAFÉXIR Admin",
      overview: "Overview",
      orders: "Orders",
      messages: "Messages",
      reviews: "Reviews",
      approve: "Approve & show",
      hide: "Hide",
      reviewStatus: { pending: "Awaiting approval", approved: "Visible", hidden: "Hidden" },
      products: "Products",
      content: "Content",
      settings: "Settings",
      status: "Status",
      save: "Save",
      saved: "Saved",
      threshold: "Free shipping threshold (EGP)",
      fee: "Shipping fee (EGP, empty = confirmed at contact)",
      notifyEmail: "Notification email (order & message alerts)",
      socials: "Social links",
      noaccess: "This area is for the brand owner. Sign in with the admin account.",
      customer: "Customer",
      notes: "Admin notes",
      price: "Price (EGP)",
      stock: "Stock (empty = untracked)",
      available: "Available",
      empty: "No orders yet.",
      signin: "Sign in",
      totalOrders: "Total orders",
      newOrders: "New orders",
      revenue: "Revenue (non-cancelled)",
      topProducts: "Top products",
      quickActions: "Quick actions",
      exportCsv: "Export orders (CSV)",
      edit: "Edit details",
      close: "Close",
      nameEn: "Name (EN)", nameAr: "Name (AR)",
      typeEn: "Type (EN)", typeAr: "Type (AR)",
      descEn: "Description (EN)", descAr: "Description (AR)",
      roastEn: "Roast (EN)", roastAr: "Roast (AR)",
      brewEn: "Brew (EN)", brewAr: "Brew (AR)",
      feelEn: "Cup feel (EN)", feelAr: "Cup feel (AR)",
      notesEn: "Tasting notes (EN, comma-separated)", notesAr: "Tasting notes (AR, comma-separated)",
      metricBody: "Body (0-10)", metricAcidity: "Acidity (0-10)", metricSweetness: "Sweetness (0-10)", metricBitterness: "Bitterness (0-10)",
      weightLabel: "Weight",
      contentHint: "Edit any text on the site — English and Arabic. Empty field keeps the original.",
      groups: { homepage: "Homepage", story: "Story section", faq: "FAQ", policies: "Policies", footer: "Footer", seo: "SEO" },
      enLabel: "English", arLabel: "العربية",
      exportNote: "Downloads all orders as a spreadsheet file.",
    },
    brew: {
      title: "Brew Ritual",
      overline: "The bag is the portal",
      generic: "Our general guidance: a medium-coarse grind, water just off the boil, and a slow, patient pour. The official recipe for this coffee is being prepared by our roastery.",
    },
    timer: {
      title: "Live Brew Companion",
      sub: "You set the pace — tap when each pour is done. The clock simply keeps you company.",
      ready: "Kettle at temperature? Scale on? Begin whenever you're ready.",
      prepare: "Prepare",
      iceStep: "Place {g} g of ice in the server",
      addWater: "Add {g} g",
      scale: "Scale reads",
      of: "of",
      drawdown: "Let it draw down, gently…",
      swirl: "Swirl gently to chill & combine",
      enjoy: "Enjoy — magic in your cup",
      totalTime: "Total time",
      start: "Begin",
      next: "Pour done",
      finish: "Done",
      reset: "Reset",
    },
    trust: {
      cod: "Cash on Delivery",
      fresh: "Fresh specialty coffee",
      freeShip: "Free delivery over EGP 2,500",
      packs: "Premium 250g packs",
      brand: "Saudi brand, now in Egypt",
    },
    howto: {
      overline: "Simple by design",
      title: "How to order",
      steps: {
        choose: "Choose your coffee — four worlds, one of them is yours.",
        place: "Place your order in a minute — name, phone, address.",
        confirm: "We call you to confirm every detail ourselves.",
        pay: "Pay cash on delivery — nothing before your coffee arrives.",
        enjoy: "Enjoy your ritual.",
      },
    },
    profile: {
      overline: "بصمتك",
      title: "Your Cup Profile, Plainly",
      flavor: "Flavor",
      acidity: "Acidity",
      body: "Body",
      sweetness: "Sweetness",
      bitterness: "Bitterness",
      roast: "Roast level",
      method: "Suggested brew",
      feel: "Overall cup feel",
      low: "Low",
      medium: "Medium",
      high: "High",
      bodyLight: "Light",
      bodyMedium: "Medium",
      bodyHeavy: "Heavy",
    },
    bundles: {
      overline: "Bundles",
      title: "Build Your Ritual",
      sub: "Choose a bundle, pick your coffees — the price is simply the sum of what you choose. Nothing inflated, nothing hidden.",
      discovery: { name: "Discovery Bundle", tag: "Any 2 coffees" },
      ritual: { name: "Ritual Bundle", tag: "Any 3 coffees" },
      full: { name: "Full CAFÉXIR Experience", tag: "All 4 coffees" },
      pick: "Choose",
      addToCart: "Add Bundle to Cart",
      added: "Bundle added to your cart",
      honestNote: "Bundle price = the exact sum of the coffees you picked.",
    },
    faq: {
      overline: "Before you ask",
      title: "Questions, answered",
      q: {
        order: "How do I order?",
        cod: "Is Cash on Delivery available?",
        coverage: "Do you deliver across Egypt?",
        deliveryFee: "How much is delivery?",
        deliveryTime: "When will I receive my order?",
        grind: "Is the coffee whole bean or ground?",
        suitsMe: "Which coffee suits me?",
        which: "Which coffee should I choose?",
        storage: "How should I store the coffee?",
        gifts: "Do you offer gifts or bundles?",
      },
      a: {
        order: "Choose your coffee, tap Add to Cart, then complete checkout — name, phone and address. We call you to confirm before anything ships.",
        cod: "Yes — Cash on Delivery is our only payment method right now. You pay nothing until your coffee is in your hands.",
        coverage: "Yes, we deliver to all governorates in Egypt.",
        deliveryFee: "EGP 90 flat for any order — and free on orders over EGP 2,500.",
        deliveryTime: "Delivery time: [PLACEHOLDER — confirmed delivery window]. We confirm the exact timing when we call you.",
        grind: "All coffees are available as whole beans. If you want it ground, we can grind it for you — both options are available when you order.",
        suitsMe: "Open the CAFÉXIR CUPPRINT — compare flavor, acidity, body, sweetness, bitterness and brewing style, then choose the profile closest to your taste.",
        which: "Take the CAFÉXIR CUPPRINT — four quick questions and your coffee reveals itself, with the reasons explained.",
        storage: "Keep the bag sealed, away from light, heat and moisture — a cool cupboard is perfect. Grind only what you brew.",
        gifts: "Yes — the Bundles section above offers Discovery (any 2 coffees), Ritual (any 3) and the Full CAFÉXIR Experience (all 4).",
      },
      suitsMeCta: "Find Your Coffee Profile",
    },
    policies: {
      title: "Policies",
      sub: "Clear terms, written plainly — because trust is part of the product.",
      shipping: {
        title: "Shipping Policy",
        points: [
          "Delivery areas: [PLACEHOLDER — coverage to be confirmed]",
          "Delivery time: [PLACEHOLDER — confirmed when we call you]",
          "Delivery fee: EGP 90 flat — free on orders over EGP 2,500",
          "Payment: Cash on Delivery",
        ],
      },
      returns: {
        title: "Returns Policy",
        points: [
          "Return/exchange conditions: [PLACEHOLDER]",
          "Damaged or wrong order: [PLACEHOLDER — contact us immediately through the contact form]",
          "We will always make a genuine mistake right.",
        ],
      },
      privacy: {
        title: "Privacy Policy",
        points: [
          "Your details are used only to confirm and deliver your order.",
          "We never sell or share customer data.",
          "We do not collect data we do not need.",
        ],
      },
      terms: {
        title: "Terms of Service",
        points: [
          "All prices are in Egyptian Pounds (EGP).",
          "Orders are confirmed after we contact you.",
          "Availability may vary by harvest and roast schedule.",
        ],
      },
    },
    reviews: {
      overline: "Guest voices",
      title: "Those who drank the elixir",
      empty: "Be the first to share your ritual.",
      shareCta: "Share your experience",
      formName: "Your name",
      formProduct: "Which coffee? (optional)",
      formText: "Tell us honestly — how was it?",
      submit: "Send",
      note: "Appears after the roastery's approval.",
      successTitle: "Thank you — received",
      successBody: "Your words will appear here once approved by our team.",
      error: "Could not send right now. Try again in a moment.",
      errName: "Please enter your name",
      errText: "Tell us a little more (at least 20 characters)",
    },
    exit: {
      title: "Before you go…",
      sub: "Four coffees only — one of them is yours. Two minutes and you'll know which.",
      quiz: "Find your Cupprint",
      shop: "Browse the coffees",
      cartTitle: "Your cart is waiting",
      cartSub: "Complete your order whenever you're ready — cash on delivery, nothing to pay now.",
      checkout: "Complete my order",
      continue: "Keep browsing",
      close: "Close",
    },
    contact: {
      overline: "Write to us",
      title: "A word, a question, a ritual shared",
      sub: "Tell us what you need — we read every message ourselves and reply personally.",
      name: "Name",
      channel: "Phone or email",
      channelHint: "One contact channel is enough — whichever you prefer.",
      subject: "Subject",
      subjects: { inquiry: "Inquiry", delivery: "Delivery issue", cancel: "Order cancellation", other: "Other" },
      message: "Your message",
      send: "Send",
      sending: "Sending…",
      successTitle: "Received, with thanks",
      successBody: "Your message reached us — expect a personal reply soon.",
      error: "Could not send right now. Please try again in a moment.",
      errName: "Please enter your name",
      errContact: "Enter a valid phone or email",
      errMessage: "Tell us a little more (at least 10 characters)",
    },
    social: { follow: "Follow CAFÉXIR" },
    nav2: { cupprint: "Cupprint" },
    orderStatus: {
      pending_confirmation: "Order received",
      confirmed: "Confirmed",
      processing: "Preparing",
      shipped: "On its way",
      delivered: "Delivered",
      cancelled: "Cancelled",
    },
    seo: {
      home: "CAFÉXIR — Saudi Specialty Coffee in Egypt",
      homeDesc: "Shop CAFÉXIR specialty coffee in Egypt. Premium 250g coffee bags including Caramel, Vanilla, Ethiopia Guji, and Ethiopia Dijammah. Cash on delivery available.",
      shop: "The Collection — CAFÉXIR",
      shopDesc: "Four coffees, each a small world of its own: Caramel, Ethiopia Guji, Ethiopia Dijammah, Vanilla — all 250g, cash on delivery in Egypt.",
      story: "Our Story — CAFÉXIR",
      storyDesc: "From Riyadh to Cairo — CAFÉXIR was born from a simple conviction: a cup of coffee can be a small daily ceremony.",
      cupprint: "CAFÉXIR CUPPRINT — Find Your Coffee",
      cupprintDesc: "Four quick questions and your elixir reveals itself — a personalized CAFÉXIR coffee match with transparent reasons and your brew ritual.",
    },
  },
  ar: {
    nav: { shop: "المتجر", story: "قصتنا", howto: "كيف تطلب", cart: "السلة", menu: "القائمة", close: "إغلاق" },
    hero: {
      overline: "قهوة مختصة سعودية — الآن في مصر",
      line1: "السحر",
      line2: "في كل كوب",
      sub: "عبوات قهوة فاخرة بحجم ٢٥٠ جرام، مصممة لطقسك اليومي وتصل إلى بابك مع الدفع عند الاستلام.",
      cta: "تسوّق القهوة",
      scroll: "مرّر للدخول",
    },
    film: {
      overline: "من المزرعة إلى فنجانك",
      cta: "تسوّق القهوة",
      chapters: {
        farm: "المزرعة",
        cherry: "الثمرة",
        harvest: "الحصاد",
        process: "المعالجة",
        roast: "التحميص",
        brew: "التخمير",
      },
    },
    marquee: ["السحر في كل كوب", "CAFÉXIR", "MAGIC IN EVERY CUP", "القهوة إكسير"],
    journey: {
      overline: "الرحلة",
      title: "من المزرعة إلى السحر",
      listen: "استمع إلى مرتفعات قوجي",
      mute: "إيقاف الصوت",
      swipeHint: "اسحب يمينًا أو يسارًا لاستكشاف الرحلة",
      prev: "السابق",
      next: "التالي",
      steps: {
        farm: { title: "المزرعة", text: "مزارع المرتفعات مع أول ضوء — هنا تبدأ كل قصة." },
        cherry: { title: "الثمرة", text: "ثمار ناضجة، تُقطف فقط عند أعمق احمرارها." },
        harvest: { title: "الحصاد", text: "تُنتقى يدويًا، ثمرةً ثمرة." },
        process: { title: "المعالجة", text: "مغسولة أو مجففة — الزمن والشمس يشكّلان الحبة." },
        roast: { title: "التحميص", text: "النار والهواء والحدس يُطلقون الإكسير." },
        brew: { title: "التخمير", text: "يلتقي الماء بالبن. يكتمل الطقس." },
        cup: { title: "الكوب", text: "تنتهي الرحلة حيث يبدأ السحر — بين يديك." },
      },
    },
    manifesto: {
      overline: "البيان",
      chapters: [
        {
          number: "٠١",
          title: "الطقس",
          content:
            "القهوة ليست مجرد شراب، بل هي استيقاظ وتأمل. لحظة مقدسة يتباطأ فيها الزمن ويتجلّى الصفاء من أعماق الفنجان.",
        },
        {
          number: "٠٢",
          title: "المصدر",
          content:
            "من غابات قوجي المرتفعة إلى أراضي كافا العريقة، ننتقي فقط الحبوب التي تحمل روحاً وقصة فريدة.",
        },
        {
          number: "٠٣",
          title: "الجسر",
          content:
            "نجمع بين أصالة القهوة السعودية وعراقة الثقافة المصرية، لنقدّم في القاهرة معياراً جديداً للقهوة المختصة.",
        },
      ],
    },
    collection: {
      overline: "اكتشف القهوة",
      title: "أربعة عوالم، طقسٌ واحد",
      sub: "كل قهوة عالمٌ صغير قائم بذاته. ادخل إليه.",
      viewAll: "استكشف المجموعة",
      discover: "ادخل",
    },
    editorial: {
      overline: "قصتنا",
      title: "من الرياض إلى القاهرة",
      body: "وُلدت CAFÉXIR من قناعة بسيطة — أن كوب القهوة يمكن أن يكون احتفاءً يومياً صغيراً. سعودية المنشأ، وتصل الآن إلى مصر.",
      cta: "اقرأ قصتنا",
    },
    product: {
      back: "عودة إلى المجموعة",
      weight: "250 غرام",
      notes: "نكهات التذوق",
      specs: "المواصفات",
      sensory: "الملف الحسّي",
      type: "النوع",
      origin: "المصدر",
      brew: "طريقة التحضير",
      altitude: "الارتفاع",
      process: "المعالجة",
      roast: "التحميص",
      form: "الشكل",
      flavor: "النكهة",
      composition: "التركيبة",
      variety: "السلالة",
      addToCart: "أضف إلى السلة",
      added: "أضيف إلى سلتك",
      grindLabel: "الطحنة",
      grind: { whole: "حبوب", ground: "مطحونة" },
      available: "متوفر",
      unavailable: "غير متوفر حاليًا",
      share: "مشاركة",
      linkCopied: "نُسخ الرابط",
      codNote: "الدفع عند الاستلام",
      freeShipHint: "توصيل مجاني للطلبات التي تتجاوز ٢٬٥٠٠ جنيه",
      value: {
        caramel: "قهوة فلتر منكّهة بالكراميل. تحميص متوسط داكن، حبوب كاملة — 80٪ أرابيكا، 20٪ روبوستا.",
        "ethiopia-guji": "فراولة ولايم وكراميل — سلالة هيرلوم مغسولة من مرتفعات قوجي، على ارتفاع 1900–2300 متر.",
        "ethiopia-dijammah": "شوكولاتة وحمضيات الليمون والتوت — معالجة طبيعية في كافا، الموطن القديم للقهوة.",
        vanilla: "قهوة فلتر منكّهة بالفانيليا. تحميص متوسط داكن، حبوب كاملة — 80٪ أرابيكا، 20٪ روبوستا.",
      },
      recipes: {
        title: "الطقوس الرسمية",
        sub: "نِسَب دقيقة، تمامًا كما تقصدها محمصتنا.",
        suggested: "طريقة التحضير المقترحة",
        hot: "V60 ساخن",
        iced: "V60 مثلج",
        dose: "البن",
        water: "الماء",
        hotWater: "ماء ساخن",
        temp: "الحرارة",
        ice: "الثلج",
        total: "الإجمالي (ماء + ثلج)",
        pours: "الصبّات",
        pour: "صبّة",
        share: "شارك الطقس",
        shared: "حُفظت البطاقة — جاهزة للنشر",
        iceSteps: [
          "ضع الثلج في الإناء قبل التحضير.",
          "حضّر القهوة فوق الثلج مباشرة، ودَع القهوة الساخنة تقطر عليه.",
          "بعد التحضير، حرّك الإناء برفق لتبريد القهوة ودمجها.",
        ],
      },
      detailsPending: "ستُنشر بقية التفاصيل مع الإطلاق الرسمي.",
      placeholder: "—",
      quantity: "الكمية",
      body: "القوام",
      acidity: "الحموضة",
      aftertaste: "النكهة الباقية",
      sweetness: "الحلاوة",
      packPlaceholder: "صورة العبوة الرسمية — عنصر مؤقت",
    },
    cart: {
      title: "سلتك",
      empty: "سلتك فارغة.",
      emptyCta: "اكتشف المجموعة",
      subtotal: "المجموع الفرعي",
      shipping: "التوصيل",
      free: "مجاني",
      shippingPending: "يُؤكَّد عند التواصل",
      freeProgress: "أضف {amount} لتحصل على توصيل مجاني",
      freeUnlocked: "ممتاز! طلبك مؤهل للتوصيل المجاني",
      checkout: "إتمام الطلب — الدفع عند الاستلام",
      remove: "إزالة",
    },
    footer: {
      tagline: "السحر في كل كوب",
      line: "قهوة مختصة سعودية — من الرياض إلى القاهرة.",
      contact: "تواصل معنا",
      howto: "كيف تطلب",
      faq: "الأسئلة الشائعة",
      policies: "السياسات",
      codLine: "الدفع عند الاستلام · توصيل مجاني فوق ٢٬٥٠٠ جنيه",
      rights: "© 2026 CAFÉXIR. جميع الحقوق محفوظة.",
    },
    story: {
      overline: "قصتنا",
      title: "القهوة إكسير",
      cta: "استكشف المجموعة",
    },
    concierge: {
      title: "دليل الإكسير",
      open: "اسأل دليل الإكسير",
      greeting: "أهلًا بك في CAFÉXIR. أخبرني عن ذوقك — مشرق، عميق، أم حلو — وسأجد لك إكسيرك.",
      placeholder: "اسأل عن قهوتنا…",
      send: "إرسال",
      unavailable: "الدليل يستريح لحظة — حاول مرة أخرى بعد قليل.",
      listen: "استمع إلى الإجابة",
      suggestions: ["أي قهوة تناسبني؟", "كيف أحضّر إثيوبيا قوجي؟", "ما الذي يميّز CAFÉXIR؟"],
    },
    auth: {
      signIn: "تسجيل الدخول",
      signOut: "تسجيل الخروج",
      title: "حسابك في CAFÉXIR",
      subtitle: "أعضاء الطقس",
      signin: "تسجيل الدخول",
      signup: "إنشاء حساب",
      name: "الاسم",
      email: "البريد الإلكتروني",
      password: "كلمة المرور (٨ أحرف فأكثر)",
      forgot: "نسيت كلمة المرور؟",
      resetSent: "إن كان البريد مسجلًا، فقد جهّزنا رابط الاستعادة.",
      emailRequired: "أدخل بريدك أولًا.",
      or: "أو",
      google: "المتابعة عبر Google",
      error: "حدث خطأ ما. حاول مرة أخرى.",
    },
    checkout: {
      title: "إتمام الطلب",
      subtitle: "الدفع عند الاستلام",
      name: "الاسم الكامل",
      phone: "رقم الهاتف",
      email: "البريد الإلكتروني (اختياري — لتحديثات الطلب)",
      governorate: "المحافظة",
      city: "المدينة / المنطقة (اختياري)",
      address: "العنوان التفصيلي",
      landmark: "علامة مميزة (اختياري)",
      notes: "ملاحظات للتوصيل (اختياري)",
      summary: "ملخص الطلب",
      codNote: "طريقة الدفع: الدفع عند الاستلام",
      confirm: "تأكيد الطلب والدفع عند الاستلام",
      placing: "جارٍ تأكيد طلبك…",
      successTitle: "تم استلام طلبك",
      successBody: "سنتواصل معك لتأكيد الطلب. احتفظ برقم طلبك:",
      continueShopping: "متابعة الاستكشاف",
      required: "هذا الحقل مطلوب",
      phoneInvalid: "أدخل رقم هاتف صحيح",
      emailInvalid: "أدخل بريدًا إلكترونيًا صحيحًا",
      error: "حدث خطأ ما. حاول مرة أخرى.",
      empty: "سلتك فارغة.",
      total: "الإجمالي المطلوب عند الاستلام",
    },
    cupprint: {
      overline: "CAFÉXIR CUPPRINT",
      title: "ذوقك. قهوتك. بصمتك.",
      sub: "أربعة أسئلة سريعة — ويكشف إكسيرك عن نفسه.",
      qTaste: "إلى ماذا تميل؟",
      sweet: "الحلو والدافئ",
      balanced: "المتوازن",
      bright: "المشرق والحيوي",
      qBody: "القوام؟",
      light: "خفيف",
      full: "ممتلئ",
      qNotes: "نكهات تحبها",
      nChocolate: "شوكولاتة",
      nFruity: "فواكه",
      nCitrus: "حمضيات",
      nCaramel: "كراميل",
      nVanilla: "فانيليا",
      nBerry: "توت",
      qBrew: "كيف تحضّر قهوتك؟",
      espresso: "إسبريسو",
      filter: "فلتر",
      both: "كلاهما",
      resultTitle: "بصمتك",
      match: "توافق",
      because: "لماذا يناسبك",
      recipe: "طقس تحضيرك",
      feedback: "جرّبته؟ أخبر الدليل",
      liked: "أحببته",
      notLiked: "لم يناسبني",
      restart: "إعادة الاختبار",
      next: "متابعة",
      start: "ابدأ",
      viewProduct: "شاهد قهوتك",
      step: "من",
      reasons: {
        sweet: "لأنك تميل إلى الحلو والدافئ",
        bright: "لأنك تميل إلى المشرق والحيوي",
        balanced: "لأنك تحب التوازن",
        espresso: "لأنك تحضّر الإسبريسو",
        filter: "لأنك تحضّر الفلتر",
        note_caramel: "لأنك تحب الكراميل",
        note_vanilla: "لأنك تحب الفانيليا",
        note_fruity: "لأنك تحب النكهات الفاكهية",
        note_citrus: "لأنك تحب الحمضيات",
        note_chocolate: "لأنك تحب الشوكولاتة",
        note_berry: "لأنك تحب التوت",
      },
    },
    account: {
      title: "حسابي",
      orders: "طلباتي",
      cupprint: "بصمتي",
      none: "لا شيء هنا بعد.",
      signinNeeded: "سجّل الدخول لعرض حسابك.",
      reorder: "إعادة الطلب",
      reordered: "أضيف إلى سلتك",
      total: "الإجمالي",
      placedOn: "التاريخ",
      adminLink: "لوحة الإدارة",
      noCupprint: "اكتشف بصمتك — أربعة أسئلة، وإكسير واحد.",
      match: "توافق",
    },
    admin: {
      title: "إدارة CAFÉXIR",
      overview: "نظرة عامة",
      orders: "الطلبات",
      messages: "الرسائل",
      reviews: "الآراء",
      approve: "اعرض في الموقع",
      hide: "إخفاء",
      reviewStatus: { pending: "بانتظار موافقتك", approved: "معروض", hidden: "مخفي" },
      products: "المنتجات",
      content: "المحتوى",
      settings: "الإعدادات",
      status: "الحالة",
      save: "حفظ",
      saved: "تم الحفظ",
      threshold: "حد التوصيل المجاني (جنيه)",
      fee: "رسوم التوصيل (جنيه — فارغ = يُؤكد عند التواصل)",
      notifyEmail: "بريد الإشعارات (تنبيهات الطلبات والرسائل)",
      socials: "روابط التواصل الاجتماعي",
      noaccess: "هذه المنطقة لصاحب العلامة. سجّل الدخول بحساب الإدارة.",
      customer: "العميل",
      notes: "ملاحظات إدارية",
      price: "السعر (جنيه)",
      stock: "المخزون (فارغ = غير متعقَّب)",
      available: "متاح",
      empty: "لا طلبات بعد.",
      signin: "تسجيل الدخول",
      totalOrders: "إجمالي الطلبات",
      newOrders: "طلبات جديدة",
      revenue: "الإيراد (بدون الملغى)",
      topProducts: "الأكثر طلبًا",
      quickActions: "إجراءات سريعة",
      exportCsv: "تصدير الطلبات (CSV)",
      edit: "تعديل التفاصيل",
      close: "إغلاق",
      nameEn: "الاسم (إنجليزي)", nameAr: "الاسم (عربي)",
      typeEn: "النوع (إنجليزي)", typeAr: "النوع (عربي)",
      descEn: "الوصف (إنجليزي)", descAr: "الوصف (عربي)",
      roastEn: "التحميص (إنجليزي)", roastAr: "التحميص (عربي)",
      brewEn: "التحضير (إنجليزي)", brewAr: "التحضير (عربي)",
      feelEn: "الإحساس بالكوب (إنجليزي)", feelAr: "الإحساس بالكوب (عربي)",
      notesEn: "نكهات التذوق (إنجليزي، مفصولة بفواصل)", notesAr: "نكهات التذوق (عربي، مفصولة بفواصل)",
      metricBody: "القوام (0-10)", metricAcidity: "الحموضة (0-10)", metricSweetness: "الحلاوة (0-10)", metricBitterness: "المرارة (0-10)",
      weightLabel: "الوزن",
      contentHint: "عدّل أي نص في الموقع — بالإنجليزية والعربية. الحقل الفارغ يُبقي النص الأصلي.",
      groups: { homepage: "الصفحة الرئيسية", story: "قسم القصة", faq: "الأسئلة الشائعة", policies: "السياسات", footer: "الفوتر", seo: "تحسين البحث" },
      enLabel: "English", arLabel: "العربية",
      exportNote: "ينزّل كل الطلبات كملف جدول.",
    },
    brew: {
      title: "طقس التحضير",
      overline: "العبوة هي البوابة",
      generic: "إرشادنا العام: طحن متوسط الخشونة، وماء قرب الغليان، وصبًّا بطيئًا بصبر. الوصفة الرسمية لهذه القهوة يجهّزها محمصنا حاليًا.",
    },
    timer: {
      title: "رفيق التحضير المباشر",
      sub: "أنت من يحدد الإيقاع — اضغط عند انتهاء كل صبّة، والساعة ترافقك فقط.",
      ready: "الغلاية على الحرارة؟ الميزان جاهز؟ ابدأ متى شئت.",
      prepare: "التجهيز",
      iceStep: "ضع {g} غ من الثلج في الإناء",
      addWater: "أضف {g} غ",
      scale: "قراءة الميزان",
      of: "من",
      drawdown: "اتركها تقطر بلطف…",
      swirl: "حرّك الإناء برفق للتبريد والدمج",
      enjoy: "استمتع — السحر في كوبك",
      totalTime: "الوقت الكلي",
      start: "ابدأ",
      next: "انتهت الصبّة",
      finish: "تم",
      reset: "إعادة",
    },
    trust: {
      cod: "الدفع عند الاستلام",
      fresh: "قهوة مختصة طازجة",
      freeShip: "توصيل مجاني فوق ٢٬٥٠٠ جنيه",
      packs: "عبوات فاخرة ٢٥٠ جم",
      brand: "براند سعودي، الآن في مصر",
    },
    howto: {
      overline: "بساطة مقصودة",
      title: "كيف تطلب",
      steps: {
        choose: "اختر قهوتك — أربع عوالم، واحد منها يشبهك.",
        place: "أرسل طلبك في دقيقة — اسمك وهاتفك وعنوانك.",
        confirm: "نتصل بك بأنفسنا لتأكيد كل تفصيلة.",
        pay: "ادفع عند الاستلام — ولا قرش قبل أن تصلك قهوتك.",
        enjoy: "استمتع بطقسك.",
      },
    },
    profile: {
      overline: "بصمتك",
      title: "بصمة كوبك، بوضوح",
      flavor: "النكهة",
      acidity: "الحموضة",
      body: "القوام",
      sweetness: "الحلاوة",
      bitterness: "المرارة",
      roast: "درجة التحميص",
      method: "طريقة التحضير المقترحة",
      feel: "الإحساس العام بالكوب",
      low: "منخفضة",
      medium: "متوسطة",
      high: "عالية",
      bodyLight: "خفيف",
      bodyMedium: "متوسط",
      bodyHeavy: "ثقيل",
    },
    bundles: {
      overline: "الباقات",
      title: "ابنِ طقسك",
      sub: "اختر الباقة ثم محاصيلك — السعر هو ببساطة مجموع ما اخترته. لا تضخيم ولا خفايا.",
      discovery: { name: "باقة ديسكفري", tag: "أي محصولين" },
      ritual: { name: "باقة ريتوال", tag: "أي ثلاثة محاصيل" },
      full: { name: "تجربة CAFÉXIR الكاملة", tag: "المحاصيل الأربعة" },
      pick: "اختر",
      addToCart: "أضف الباقة إلى السلة",
      added: "أضيفت الباقة إلى سلتك",
      honestNote: "سعر الباقة = مجموع أسعار المحاصيل التي اخترتها بالضبط.",
    },
    faq: {
      overline: "قبل أن تسأل",
      title: "أسئلة وإجابات",
      q: {
        order: "كيف أطلب؟",
        cod: "هل الدفع عند الاستلام متاح؟",
        coverage: "هل توصلون لجميع محافظات مصر؟",
        deliveryFee: "كم رسوم التوصيل؟",
        deliveryTime: "متى يصلني طلبي؟",
        grind: "هل القهوة حبوب أم مطحونة؟",
        suitsMe: "أي قهوة تليق بي؟",
        which: "كيف أختار قهوتي؟",
        storage: "كيف أخزّن القهوة؟",
        gifts: "هل توفّرون هدايا أو باقات؟",
      },
      a: {
        order: "اختر قهوتك، اضغط «أضف إلى السلة»، ثم أكمل الطلب — الاسم والهاتف والعنوان. نتصل بك للتأكيد قبل أي شيء.",
        cod: "نعم — الدفع عند الاستلام هو وسيلتنا الوحيدة حاليًا. لا تدفع شيئًا حتى تصبح القهوة بين يديك.",
        coverage: "نعم، نوصل لجميع محافظات مصر.",
        deliveryFee: "90 جنيهًا ثابتة لأي طلب — ومجاني فوق ٢٬٥٠٠ جنيه.",
        deliveryTime: "مدة التوصيل: [PLACEHOLDER — نافذة التوصيل المؤكدة]. نؤكد التوقيت بدقة عند اتصالنا بك.",
        grind: "كل المحاصيل متوفرة حبوب. وإذا رغبت أن تكون مطحونة، نوفر لك خيار الطحن — الخياران متوفران عند الطلب.",
        suitsMe: "انتقل إلى قسم بصمتك لمقارنة النكهة، الحموضة، القوام، الحلاوة، المرارة، وطريقة التحضير — واختر البصمة الأقرب لذوقك.",
        which: "جرّب CAFÉXIR CUPPRINT — أربعة أسئلة سريعة وتكشف قهوتك عن نفسها، مع شرح الأسباب.",
        storage: "أبقِ العبوة محكمة بعيدًا عن الضوء والحرارة والرطوبة — خزانة المطبخ الباردة مثالية. واطحن قدر ما تحضّر فقط.",
        gifts: "نعم — في قسم الباقات أعلاه: ديسكفري (محصولان)، ريتوال (ثلاثة)، وتجربة CAFÉXIR الكاملة (الأربعة).",
      },
      suitsMeCta: "اكتشف بصمتك",
    },
    policies: {
      title: "السياسات",
      sub: "شروط واضحة بلغة صريحة — لأن الثقة جزء من المنتج.",
      shipping: {
        title: "سياسة الشحن",
        points: [
          "مناطق التوصيل: [PLACEHOLDER — تُؤكد التغطية قريبًا]",
          "مدة التوصيل: [PLACEHOLDER — تُؤكد عند اتصالنا بك]",
          "رسوم التوصيل: 90 جنيهًا ثابتة — ومجاني فوق ٢٬٥٠٠ جنيه",
          "الدفع: عند الاستلام",
        ],
      },
      returns: {
        title: "سياسة الاسترجاع",
        points: [
          "شروط الاسترجاع أو الاستبدال: [PLACEHOLDER]",
          "طلب تالف أو خاطئ: [PLACEHOLDER — راسلنا فورًا من نموذج التواصل]",
          "أي خطأ منّا نصلحه دائمًا — هذا وعد.",
        ],
      },
      privacy: {
        title: "سياسة الخصوصية",
        points: [
          "بياناتك تُستخدم فقط لتأكيد طلبك وتوصيله.",
          "لا نبيع بيانات العملاء ولا نشاركها أبدًا.",
          "لا نجمع بيانات لا نحتاجها.",
        ],
      },
      terms: {
        title: "شروط الخدمة",
        points: [
          "جميع الأسعار بالجنيه المصري.",
          "يُعتمد الطلب بعد اتصالنا بك وتأكيده.",
          "التوفر قد يتغير بحسب مواسم الحصاد والتحميص.",
        ],
      },
    },
    reviews: {
      overline: "أصوات الضيوف",
      title: "الذين شربوا الإكسير",
      empty: "كن أول من يشارك طقسه.",
      shareCta: "شاركنا تجربتك",
      formName: "اسمك",
      formProduct: "أي قهوة؟ (اختياري)",
      formText: "حدّثنا بصدق — كيف كانت؟",
      submit: "أرسل",
      note: "يظهر رأيك بعد موافقة المحمصة.",
      successTitle: "شكرًا — وصلنا رأيك",
      successBody: "ستظهر كلماتك هنا بعد موافقة فريقنا.",
      error: "تعذّر الإرسال الآن. حاول بعد قليل.",
      errName: "أدخل اسمك من فضلك",
      errText: "حدّثنا بالمزيد (20 حرفًا على الأقل)",
    },
    exit: {
      title: "قبل أن ترحل…",
      sub: "أربع قهوات فقط — واحدة منها تشبهك. دقيقتان وستعرف أيهما.",
      quiz: "اكتشف بصمتك",
      shop: "تصفح القهوات",
      cartTitle: "سلتك في انتظارك",
      cartSub: "أكمل طلبك متى جاهزت — الدفع عند الاستلام، لا شيء عليك الآن.",
      checkout: "أكمل طلبي",
      continue: "أكمل التصفح",
      close: "إغلاق",
    },
    contact: {
      overline: "اكتب لنا",
      title: "كلمة، سؤال، أو طقسٌ نتشاركه",
      sub: "أخبرنا بما تحتاج — نقرأ كل رسالة بأنفسنا ونرد عليك شخصيًا.",
      name: "الاسم",
      channel: "الهاتف أو البريد الإلكتروني",
      channelHint: "وسيلة تواصل واحدة تكفي — أيهما تفضّل.",
      subject: "الموضوع",
      subjects: { inquiry: "استفسار", delivery: "مشكلة توصيل", cancel: "إلغاء طلب", other: "أخرى" },
      message: "رسالتك",
      send: "أرسل",
      sending: "جارٍ الإرسال…",
      successTitle: "وصلتنا رسالتك، شكرًا",
      successBody: "سنعود إليك بردٍ شخصي قريبًا.",
      error: "تعذّر الإرسال الآن. حاول مرة أخرى بعد قليل.",
      errName: "أدخل اسمك من فضلك",
      errContact: "أدخل هاتفًا أو بريدًا إلكترونيًا صحيحًا",
      errMessage: "أخبرنا بالمزيد (10 أحرف على الأقل)",
    },
    social: { follow: "تابع CAFÉXIR" },
    nav2: { cupprint: "بصمتك" },
    orderStatus: {
      pending_confirmation: "تم استلام الطلب",
      confirmed: "تم التأكيد",
      processing: "قيد التحضير",
      shipped: "في الطريق",
      delivered: "تم التوصيل",
      cancelled: "ملغي",
    },
    seo: {
      home: "CAFÉXIR — قهوة مختصة سعودية، الآن في مصر",
      homeDesc: "قهوة مختصة سعودية، الآن في مصر. أربع قهوات 250 غرام — كراميل، إثيوبيا قوجي، إثيوبيا ديجاماه، فانيليا. الدفع عند الاستلام. السحر في كل كوب.",
      shop: "المجموعة — CAFÉXIR",
      shopDesc: "أربع قهوات، كل واحدة عالمٌ قائم بذاته: كراميل، إثيوبيا قوجي، إثيوبيا ديجاماه، فانيليا — 250 غرام، والدفع عند الاستلام في مصر.",
      story: "قصتنا — CAFÉXIR",
      storyDesc: "من الرياض إلى القاهرة — وُلدت CAFÉXIR من قناعة بسيطة: كوب القهوة يمكن أن يكون احتفاءً يوميًا صغيرًا.",
      cupprint: "CAFÉXIR CUPPRINT — اكتشف قهوتك",
      cupprintDesc: "أربعة أسئلة سريعة ويكشف إكسيرك عن نفسه — توصية قهوة شخصية بأسباب شفافة وطقس تحضيرك الخاص.",
    },
  },
};
